module.exports = __webpack_public_path__ + "static/media/CQY_WHITE.6e8997bc.png";